import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
var OVERFLOW = 100;
export var useShowFixedActionBar = function useShowFixedActionBar(withoutHidden) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isHidden = _useState2[0],
    setIsHidden = _useState2[1];
  var handleScroll = useCallback(function () {
    if (typeof document !== 'undefined') {
      var _document$documentEle = document.documentElement,
        scrollTop = _document$documentEle.scrollTop,
        clientHeight = _document$documentEle.clientHeight,
        offsetHeight = _document$documentEle.offsetHeight;
      setIsHidden(scrollTop + OVERFLOW >= offsetHeight - clientHeight || scrollTop < OVERFLOW);
    }
  }, []);
  useEffect(function () {
    window.addEventListener('scroll', handleScroll);
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
  return withoutHidden ? false : isHidden;
};